import React, { useContext } from 'react';
import { LanguageContext } from './LanguageContext';
import "./AboutUs.css";
import { Link } from 'react-router-dom';
// Import carousel library if using one
// import Slider from "react-slick"; // Example for react-slick

function AboutUs() {
    const { language } = useContext(LanguageContext);

    // Example settings for a carousel
    // const settings = {
    //     dots: true,
    //     infinite: true,
    //     speed: 500,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    // };

    return (
        <div className="about-page">
            {/* Hero Banner */}
            <section className="hero-banner">
                <div className="hero-content">
                    <h1 className="brand-title">Tacosoft</h1>
                    <h className="hero-title">
                        {language === 'en' ? 'Empowering Businesses since 2000' : '2000 Yılından Beri İşletmeleri Güçlendiriyoruz'}
                    </h>
                    <p className="hero-subtitle">
                        {language === 'en'
                            ? 'At Tacosoft, we craft intelligent, future-ready solutions that inspire growth, boost efficiency, and redefine possibilities. We cooperate with the Turkish government\'s technopark to improve our software Maestro. Additionally, our servers run in one of the world\'s most secure data centers, Equinix.'
                            : 'Tacosoft, 2000 yılından beri işletmelerin güçlendirilmesi ve verimliliğinin artırılması için güçlü ve geleceğe hazır çözümler tasarlıyor. Türk hükümetinin teknoparkı ile işbirliği içinde, yazılımımız Maestro\'yu iyileştirdik. Ayrıca, sunucularımız dünyanın en güvenli veri merkezlerinden biri olan Equinix\'te çalışıyor.'}
                    </p>
                </div>
            </section>

            {/* Company Overview */}
            <section className="company-overview">
                <h2 className="section-title">
                    {language === 'en' ? 'Who We Are' : 'Biz Kimiz'}
                </h2>
                <p className="section-text">
                    {language === 'en'
                        ? `Tacosoft is more than just a software company. With over two decades of expertise, we are a trailblazer in crafting cutting-edge web solutions for industries spanning production, tourism, education, health, and logistics. We don't just build software; we empower businesses to thrive in an ever-evolving digital world.`
                        : `Tacosoft, üretim, turizm, eğitim, sağlık ve lojistik endüstrilerinde keskin köşelerle keskin çözümler tasarlıyor. İşletmelerin her zaman değişen dijital dünyada yaşamaya devam etmek için yazılımlarımızı değil, işletmeleri güçlendirmek için tasarlıyoruz.`}
                </p>
            </section>

            {/* Mission, Vision, Core Values */}
            <section className="mission-vision">
                <div className="mission">
                    <h3 className="section-title">
                        {language === 'en' ? 'Our Mission' : 'Misyonumuz'}
                    </h3>
                    <p className="section-text">
                        {language === 'en'
                            ? 'To create transformative software solutions that simplify complexity, amplify productivity, and deliver lasting value to our clients worldwide. While developing software, we also stand on the side of our clients by listening to their wishes.'
                            : 'Misyonumuz, müşterilerimize uzun vadeli değer sunmak içindir. Yazılımlarımızı geliştirirken, müşterilerimize isteklerine duyarlı olarak duruyoruz.'}
                    </p>
                </div>
                <div className="mission">
                    <h3 className="section-title">
                        {language === 'en' ? 'Our Vision' : 'Vizyonumuz'}
                    </h3>
                    <p className="section-text">
                        {language === 'en'
                            ? 'To lead the digital revolution by merging human creativity with technological advancements, creating a brighter and smarter future for businesses everywhere. We will adapt our software to up-to-date technologies and thus take them to the highest level.'
                            : 'Dijital devrimi birleştirerek, işletmelerin her yerde daha aydınlatıcı ve akıllı bir geleceğe ulaşması için, yazılımlarımızı güncel teknolojilere uydurarak onları en yüksek seviyeye taşımak için görevlendik.'}
                    </p>
                </div>
                <div className="mission">
                    <h3 className="section-title">
                        {language === 'en' ? 'Our Core Values' : 'Temel Değerlerimiz'}
                    </h3>
                    <ul className="section-list">
                        <li>{language === 'en' ? 'Innovation: Pushing boundaries with bold ideas and cutting-edge solutions.' : 'Yenilik: Cesur fikirler ve ileri çözümlerle sınırları zorluyoruz.'}</li>
                        <li>{language === 'en' ? 'Customer Focus: Putting your needs at the heart of everything we do.' : 'Müşteri Odaklılık: İhtiyaçlarınızı yaptığımız her şeyin merkezine koyuyoruz.'}</li>
                        <li>{language === 'en' ? 'Integrity: Building trust through transparency and ethical practices.' : 'Dürüstlük: Şeffaflık ve etik uygulamalarla güven inşa ediyoruz.'}</li>
                        <li>{language === 'en' ? 'Excellence: Striving for perfection in every project, every time.' : 'Mükemmeliyet: Her projede, her zaman mükemmellik için çabalıyoruz.'}</li>
                    </ul>
                </div>
            </section>

            {/* Our Solutions */}
            <section className="solutions">
                <h2 className="section-title">
                    {language === 'en' ? 'What We Offer' : 'Neler Sunuyoruz'}
                </h2>
                {/* Carousel wrapper */}
                {/* <Slider {...settings}> */}
                <div className="solutions-grid">
                    <a href='/products/maestro' className="link-reset">
                        <div className="solution-card">
                            <h4 className="solution-title">Maestro (CMMS)</h4>
                            <p className="solution-description">
                                {language === 'en'
                                    ? 'Transform your maintenance operations with Maestro, our flagship Computerized Maintenance Management System. Optimize performance, minimize downtime, and drive efficiency.'
                                    : 'Maestro, bizim lider bilgisayar destekli bakım yönetim sistemi ile, işletmelerin performansını iyileştirmek, düşük çalışma süresi ve verimliliği artırmak içindir.'}
                            </p>
                        </div>
                    </a>
                    <div className="solution-card">
                        <h4 className="solution-title">Hazmat</h4>
                        <p className="solution-description">
                            {language === 'en'
                                ? 'Ensure safety and compliance with Hazmat, our specialized hazardous substances inventory management system. Keep your operations secure and seamless.'
                                : 'Hazmat, özel koruyucu madde envanter yönetim sistemi ile, işletmelerinin güvenli ve düzgün çalışmasını sağlar.'}
                        </p>
                    </div>
                    <div className="solution-card">
                        <h4 className="solution-title">IBoard</h4>
                        <p className="solution-description">
                            {language === 'en'
                                ? 'IBoard is a direction and location finding system that helps you find your way around.'
                                : 'IBoard, yön ve konum bulma sistemi, yönünüzü bulmanıza yardımcı olur.'}
                        </p>
                    </div>
                    <div className="solution-card">
                        <h4 className="solution-title">Apartment Management System</h4>
                        <p className="solution-description">
                            {language === 'en'
                                ? 'Apartment Management System is a system that helps you manage your apartment.'
                                : 'Apartman Yönetim Sistemi, apartmanınızı yönetmenize yardımcı olan bir sistemdir.'}
                        </p>
                    </div>
                </div>
                {/* </Slider> */}
            </section>

            {/* Testimonials */}
            <section className="testimonials">
                <h2 className="section-title">
                    {language === 'en' ? 'What Our Clients Say' : 'Müşterilerimiz Ne Diyor'}
                </h2>
                <div className="testimonial-card">
                    <p>
                        {language === 'en'
                            ? '"Tacosoft has revolutionized the way we handle maintenance. Their attention to detail and innovative solutions make them the go-to partner for digital transformation."'
                            : '"Tacosoft, bakım işlemlerimizi devrim niteliğinde değiştirdi. Detaylara gösterdikleri özen ve yenilikçi çözümleri, onları dijital dönüşüm için başvurulacak ortak yapıyor."'}
                    </p>
                    <span>- Koç High School</span>
                </div>
                <div className="testimonial-card">
                    <p>
                        {language === 'en'
                            ? '"Working with Tacosoft was a game-changer. Their customer-focused approach and cutting-edge tools have significantly improved our operations."'
                            : '"Tacosoft ile çalışmak bir dönüm noktasıydı. Müşteri odaklı yaklaşımları ve ileri teknolojik araçları, operasyonlarımızı önemli ölçüde geliştirdi."'}
                    </p>
                    <span>- Capitol Shopping Mall</span>
                </div>
            </section>

            {/* Contact CTA */}
            <section className="contact-cta">
                <h2 className="cta-title">
                    {language === 'en' ? "Let's Build the Future Together" : 'Geleceği Birlikte İnşa Edelim'}
                </h2>
                <p className="cta-text">
                    {language === 'en'
                        ? 'Ready to take your business to the next level? Partner with Tacosoft and experience the power of transformative technology tailored just for you.'
                        : 'İşletmenizi bir sonraki seviyeye taşımaya hazır mısınız? Tacosoft ile ortak olun ve size özel dönüştürücü teknolojinin gücünü deneyimleyin.'}
                </p>
                <Link to="/contact">
                    <button className="cta-button">
                        {language === 'en' ? 'Contact Us' : 'Bize Ulaşın'}
                    </button>
                </Link>
            </section>
        </div>
    );
}

export default AboutUs;
